module.exports = __webpack_public_path__ + "static/media/washington-jorge-alcala.4d8d7479.jpg";